import React, { useEffect, useState } from 'react'
import './style.css'

function ChooseTheBest() {

  const [sliderIndex, setSliderIndex] = useState(0);
  const sliderImages = [
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
    '/images/CustomImages/ChooseTheBestImages/1.jpg',
    '/images/CustomImages/ChooseTheBestImages/2.jpg',
    '/images/CustomImages/ChooseTheBestImages/3.jpg',
    '/images/CustomImages/ChooseTheBestImages/4.jpg',
    '/images/CustomImages/ChooseTheBestImages/5.jpg',
    '/images/CustomImages/ChooseTheBestImages/6.jpg',
  ];

  const runSlider = (index) => {
    const slides = document.querySelector('.ChooseTheBest_slides');
    slides.style.transform = `translateX(-${sliderIndex * 35}rem)`;
  }

  useEffect(() => {
    const SliderInterval = setInterval(() => {
      setSliderIndex(prev => (prev + 1) % sliderImages.length);
    }, 2000);

    return () => clearInterval(SliderInterval);
  }, []);

  useEffect(() => {
    runSlider(sliderIndex);
  }, [sliderIndex])



  return (
    <div id='ChooseTheBest_no-bootstrap-zone'>
      <div className='ChooseTheBest_main_container'>
        <div className='ChooseTheBest_left_container'>
          <h3>Choose the Best in Web Design</h3>
          <p>Our UI/UX web design and web development services create a digital identity for your business. Our responsive website designs are visually stunning and engage visitors, leading to online success and business growth.</p>
          <ul>
            <li>USER FOCUSED WEBSITE DESIGN</li>
            <li>SEARCH ENGINE FRIENDLY</li>
            <li>MOBILE RESPONSIVE DESIGN</li>
            <li>WEB DESIGN TO GET YOU NOTICED</li>
          </ul>
        </div>
        <div className='ChooseTheBest_right_container'>
          <div className='ChooseTheBest_slides'>
            {sliderImages.map((item, i) => {
              return (
                <img key={i} src={sliderImages[i]} className='ChooseTheBest_slide' loading='lazy' />
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChooseTheBest;